import React, {useEffect, useState} from 'react';
import { Container } from '@material-ui/core';
import CPCCompanyInfoView from './CPCCompanyInfo.view';
import CPCProgramInfoView from './CPCProgramInfo.view';
import useStyles from '../../../../assets/styles/ProgramRatingStyles';
import {Box, Button, Step, StepLabel, Stepper} from "@mui/material";
import {RATING_STEPS} from "../../../../utils/RatingFlowSteps";

const CPCCompanyProgramInfoView = ({ data, actions, options }) => {
    const classes = useStyles();
    const { company_data, program_data, activeStatus } = data;
    const { company_actions, program_actions } = actions;
    const { company_options, program_options, setActiveStatus} = options;
    const activeStep = RATING_STEPS.findIndex(step => step.status === activeStatus);

    const companyInfo = data.company_data.defaultInitialValues;
    const programInfo = data.program_data.defaultInitialValues;
    const handleNext = () => {
        const currentStepIndex = RATING_STEPS.findIndex(step => step.status === activeStatus);
        if (currentStepIndex < RATING_STEPS.length - 1) {
            setActiveStatus(RATING_STEPS[currentStepIndex + 1].status);
        }
    };

    const handleBack = () => {
        const currentIndex = RATING_STEPS.findIndex(step => step.status === activeStatus);

        if (currentIndex > 0) {
            const prevStatus = RATING_STEPS[currentIndex - 1].status;
            setActiveStatus(prevStatus);
            console.log(`Navigating back from ${activeStatus} to ${prevStatus}`);
        } else {
            console.log('Already at first step, cannot go back');
        }
    };

    useEffect(() => {
        window.scrollTo(0 , 0);
    }, [activeStatus]);

    const handleCompanyDataChange = (values) => {
        actions.company_actions.handleCompanyDataChange(values);
    };

    const handleProgramDataChange = (values) => {
        actions.program_actions.handleProgramDataChange(values);
    };

    const combinedSubmitAction = (programValues) => {
        const combinedData = {
            ...companyInfo,
            ...programValues,
        };
        program_actions.submitAction(combinedData);
    };

    return (
        <Container className={classes.container}>
            <Box sx={{ p: 3 }}>
                <Stepper
                    activeStep={activeStep}
                    alternativeLabel
                    sx={{
                        '& .MuiStepLabel-root .Mui-completed': {
                            color: '#ff6468ff'
                        },
                        '& .MuiStepLabel-root .Mui-active': {
                            color: '#ff6468ff'
                        },
                        '& .MuiStepLabel-root .Mui-disabled': {
                            color: '#ff6468ff',
                            opacity: 0.5
                        },
                        '& .MuiStepConnector-root .MuiStepConnector-line': {
                            borderColor: '#ff6468ff',
                            borderTopWidth: '6px',
                            // marginTop: '-12px'
                        }
                    }}
                >
                    {RATING_STEPS.map((step) => (
                        <Step key={step.label}>
                            <StepLabel
                                StepIconProps={{
                                    sx: {
                                        '&.Mui-completed': {
                                            color: '#ff6468ff',
                                            fontSize: '1.7rem',
                                            '& .MuiStepIcon-text': {
                                                display: 'none'
                                            }
                                        },
                                        '&.Mui-active': {
                                            color: '#ff6468ff',
                                            fontSize: '1.7rem',
                                            '& .MuiStepIcon-text': {
                                                display: 'none'
                                            }
                                        },
                                        fontSize: '1.7rem',
                                        '& .MuiStepIcon-text': {
                                            display: 'none'
                                        }
                                    }
                                }}
                            >
                                {step.label}
                            </StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Box>

            {activeStatus === 'ORGANIZATION_INFO' && (
                <>
                    <CPCCompanyInfoView
                        data={{
                            ...company_data,
                            companyInfo: data.company_data.defaultInitialValues,
                            currentStatus: activeStatus
                        }}
                        actions={{
                            submitAction: company_actions.submitAction,
                            handleCompanyDataChange,
                            onNext: handleNext
                        }}
                        options={company_options}
                    />
                    {/*<Box display="flex" justifyContent="center" mt={2}>*/}
                    {/*    <Button*/}
                    {/*        variant="contained"*/}
                    {/*        className={classes.badgeButton}*/}
                    {/*        onClick={handleNext}*/}
                    {/*        disabled={!companyInfo.NameOrg}*/}
                    {/*    >*/}
                    {/*       Next*/}
                    {/*    </Button>*/}
                    {/*</Box>*/}
                </>
            )}

            {activeStatus === 'PROGRAM_INFO' && (
                <CPCProgramInfoView
                    data={{
                        ...program_data,
                        programInfo: data.program_data.defaultInitialValues,
                        currentStatus: activeStatus
                    }}
                    actions={{
                        submitAction: program_actions.submitAction,
                        onBack: handleBack,
                        handleProgramDataChange
                    }}
                    options={program_options}
                />
            )}
        </Container>
    );
};

export default CPCCompanyProgramInfoView;